var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"px-6 pa-6"},[_c('DoughnutChart',{attrs:{"chartdata":_vm.datacollection,"options":_vm.options,"animation.animateRotate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }